module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-2.9033a717.png";